import React from "react";
import { colors } from "../../styles";

export const GoiHeaderBanner = () => (
  <div
    style={{
      padding: "12px 16px",
      fontSize: "12px",
      color: colors.white,
      background: colors.gray900,
    }}
  >
    장례 비용, 장례식장 정보, 예상 견적 - 고이장례연구소 자체 추산
  </div>
);
